'use client';

import React, { useMemo } from 'react';
import { ToastContainer, Zoom } from 'react-toastify';

import { useWindowDimensions } from '@/helpers/hooks';

import 'react-toastify/dist/ReactToastify.css';
import './style.css';

import { TOAST_AUTOCLOSE_TIME } from '@/config/env';

import {
  ADD_TO_CART_TOAST,
  ADD_TO_EXISTING_EZ_SHIP_TOAST,
  AUTH_MODAL_TOAST_CONTAINER,
  DEFAULT_TOAST,
} from './containerIds';
import ToastIcon from './ToastIcon';

const ToastWrapper = () => {
  const dimensions = useWindowDimensions();

  const addToExistingEzShipToastStyle = useMemo(() => {
    if (dimensions.width >= 793) {
      return { width: '765px' };
    } else {
      return { width: '320px' };
    }
  }, [dimensions]);

  const addToCartToastStyle = useMemo(() => {
    if (dimensions.width >= 793) {
      return { width: '549px' };
    } else {
      return { width: '355px' };
    }
  }, [dimensions]);

  return (
    <>
      <ToastContainer
        limit={1}
        position="top-right"
        transition={Zoom}
        autoClose={TOAST_AUTOCLOSE_TIME}
        containerId={DEFAULT_TOAST}
        enableMultiContainer
        icon={ToastIcon}
        closeOnClick={false}
        closeButton={false}
        hideProgressBar
        toastClassName="!v2-p-[7px] !v2-border !v2-rounded-xl !v2-shadow-auth-toast-card sm:!v2-mx-0 !v2-mx-4 !v2-mt-5"
        bodyClassName="!v2-p-0 v2-basic-toast-body"
      />

      <ToastContainer
        transition={Zoom}
        autoClose={TOAST_AUTOCLOSE_TIME}
        // autoClose={false}
        // pauseOnFocusLoss
        style={addToCartToastStyle}
        containerId={ADD_TO_CART_TOAST}
        enableMultiContainer
        // className="!sm:v2-ml-auto v2-ml-auto v2-mt-[10px] before:fixed before:top-0 before:left-0 before:h-full before:w-full before:rounded-[4px] before:bg-transparent before:transition-all before:content-[''] before:duration-300"
        toastClassName="!v2-overflow-visible !v2-rounded-md add-to-cart-toast"
        closeButton={false}
        closeOnClick={false}
        position="top-right"
        hideProgressBar
        pauseOnHover={true}
      />
      <ToastContainer
        transition={Zoom}
        autoClose={TOAST_AUTOCLOSE_TIME}
        style={addToExistingEzShipToastStyle}
        icon={false}
        toastClassName="!v2-overflow-visible !v2-rounded-xl !v2-p-0"
        bodyClassName="!v2-py-4 !v2-pr-3 !v2-bg-gray-600"
        containerId={ADD_TO_EXISTING_EZ_SHIP_TOAST}
        enableMultiContainer
        closeButton={false}
        closeOnClick={false}
        position="top-right"
        hideProgressBar
      />
      <ToastContainer
        transition={Zoom}
        autoClose={TOAST_AUTOCLOSE_TIME}
        icon={false}
        toastClassName="!v2-p-[7px] !v2-border !v2-rounded-xl !v2-shadow-auth-toast-card sm:!v2-mx-0 !v2-mx-4 !v2-mb-5"
        bodyClassName="!v2-p-0 auth-modal-toast-body"
        containerId={AUTH_MODAL_TOAST_CONTAINER}
        enableMultiContainer
        closeButton={false}
        closeOnClick={false}
        position="bottom-right"
        hideProgressBar
      />
    </>
  );
};

export default ToastWrapper;
